import React, { Component } from 'react';
import {Button,Collapse,UncontrolledCollapse} from 'reactstrap';
import './../UploadData.css';
import SortableTree from 'react-sortable-tree';
import InfoMessage from '../../../components/Message/InfoMessage/InfoMessage';

class ReviewMapping extends Component {

  constructor(props){
    super(props);
    console.log(this.props.existingMapping)
  }

  showPerformanceGradeCollapse = () => {
    const {mapping} = this.props.existingMapping;
    const {performance} = mapping;
    if(performance) {
      return(
        <div>
          <div className="review-mapping-row">
            <div>
              Matched Column: <span style={{fontWeight:'lighter'}}>{performance.columnName}</span>
            </div>
          </div>
          
          <div className="review-mapping-row" id={`toggler-performance`}>
            <div>
              Mapped {performance.data.length} of {performance.data.length} values to performance ratings
            </div>
            <div>
              <i className="review-mapping-row flaticon-down"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-performance`}>
          {
            performance.data.map((data,i) => {
              return(
                <div key={i} className="review-mapping-collapse">
                  {data.values.join(', ')} 
                  <span style={{fontWeight:'lighter',marginLeft:'5px'}}>
                  mapped to
                  </span> {data.reference.name}
                </div>
              )
            })
          }
          </UncontrolledCollapse>
          
        </div>
      )
    }
  }

  showOccupationsAndSeniorityCollapse = () => {
    const {mapping} = this.props.existingMapping;
    const {occupation,seniority} = mapping;
    if(occupation && seniority) {
      return(
        <div>
          <div className="review-mapping-row" id={`toggler-os-column`}>
            <div>
              Matched 2 columns
            </div>
            <div>
              <i className="review-mapping-row flaticon-down"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-os-column`}>
            <div className="review-mapping-collapse">
              <div>
                Occupation Column: <span style={{fontWeight:'lighter'}}>{occupation.columnName}</span>
              </div>
              <div>
                Seniority Column: <span style={{fontWeight:'lighter'}}>{seniority.columnName}</span>
              </div>
            </div>
          </UncontrolledCollapse>
          
          <div className="review-mapping-row" id={`toggler-os-matched`}>
            <div>
              Mapped {occupation.data.length} of {occupation.data.length} positions to occupational categories
            </div>
            <div>
              <i className="review-mapping-row flaticon-down"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-os-matched`}>
            {
              occupation.data.map((data,i) => {
                return(
                    <div key={i} className="review-mapping-collapse">
                      {data.values.join(', ')} 
                      <span style={{fontWeight:'lighter',marginLeft:'5px'}}>
                      mapped to
                      </span> {data.reference.name}
                    </div>
                )
              })
            }
          </UncontrolledCollapse>
          
          <div className="review-mapping-row" id={`toggler-os-matched-s`}>
            <div>
              Mapped {seniority.data.length} of {seniority.data.length} positions to job categories
            </div>
            <div>
              <i className="review-mapping-row flaticon-down"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-os-matched-s`}>
            {
              seniority.data.map((data,i) => {
                return(
                    <div key={i} className="review-mapping-collapse">
                      {data.values.join(', ')} 
                      <span style={{fontWeight:'lighter',marginLeft:'5px'}}>
                      mapped to
                      </span> {data.reference.name}
                    </div>
                )
              })
            }
          </UncontrolledCollapse>
          
        </div>
      )
    }
  }

  showGenderTypesCollapse = () => {
    const {mapping} = this.props.existingMapping;
    const {gender} = mapping;
    return(
      <div>
        <div className="review-mapping-row">
          <div>
            Matched Column: <span style={{fontWeight:'lighter'}}>{gender.columnName}</span>
          </div>
        </div>
        
        <div className="review-mapping-row" id={`toggler-gender`}>
          <div>
            Mapped {gender.data.length} of {gender.data.length} values to gender types 
          </div>
          <div>
            <i className="review-mapping-row flaticon-down"></i>
          </div>
        </div>
        <UncontrolledCollapse toggler={`toggler-gender`}>
          {
            gender.data.map((data,i) => {
              // console.log("adadasdd");
              // console.log(data);
              return(
                <div key={i} className="review-mapping-collapse">
                  {data.values.join(', ')} 
                  <span style={{fontWeight:'lighter',marginLeft:'5px'}}>
                  mapped to
                  </span> {data.key}
                </div>
              )
            })
          }
        </UncontrolledCollapse>
        
      </div>
    )
  }


  showEthnicityTypesCollapse = () => {
    const {mapping} = this.props.existingMapping?this.props.existingMapping:""
    const {ethnicity} = mapping
    if(ethnicity){
      return(
        <div>
          <div className="review-mapping-row">
            <div>
              Matched Column: <span style={{fontWeight:'lighter'}}>{ethnicity.columnName}</span>
            </div>
          </div>
          
          <div className="review-mapping-row" id={`toggler-ethnicity`}>
            <div>
              Mapped {ethnicity.data.length} of {ethnicity.data.length} values to ethnicity types 
            </div>
            <div>
              <i className="review-mapping-row flaticon-down"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-ethnicity`}>
            {
              ethnicity.data.map((data,i) => {
                // console.log("adadasdd");
                // console.log(data);
                return(
                  <div key={i} className="review-mapping-collapse">
                    {data.values.join(', ')} 
                    <span style={{fontWeight:'lighter',marginLeft:'5px'}}>
                    mapped to
                    </span> {data.key}
                  </div>
                )
              })
            }
          </UncontrolledCollapse>
          
        </div>
      )
    }
    
  }

  handleTreeChange = () => {
    //do nothing.
  }

  showSeprationCollapse = () => {
    const {mapping} = this.props.existingMapping;
    const {separation} = mapping;
    if(separation) {
      return(
        <div>
          <div className="review-mapping-row">
            <div>
              Matched Column: <span style={{fontWeight:'lighter'}}>{separation.columnName}</span>
            </div>
          </div>
          
          <div className="review-mapping-row" id={`toggler-separation`}>
            <div>
              Mapped {separation.data.length} of {separation.data.length} values to separation categories
            </div>
            <div>
              <i className="review-mapping-row flaticon-down"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-separation`}>
          {
            separation.data.map((data,i) => {
              return(
                <div key={i} className="review-mapping-collapse">
                  {data.values.join(', ')} 
                  <span style={{fontWeight:'lighter',marginLeft:'5px'}}>
                  mapped to
                  </span> {data.reference.name}
                </div>
              )
            })
          }
          </UncontrolledCollapse>
          
        </div>
      )
    }
  }

  showOrgChartCollapse = () => {
    const {mappedColumns,staticHierarchy} = this.props.organizationData;
    return(
      <div>
        <div className="review-mapping-row">
          <div>
            Matched Column: <span style={{fontWeight:'lighter'}}>{mappedColumns[0]}</span>
          </div>
        </div>
        
        <div className="review-mapping-row" id={`toggler-org-chart`}>
          <div>
            Office Hierarchy
          </div>
          <div>
            <i className="review-mapping-row flaticon-down"></i>
          </div>
        </div>
        <UncontrolledCollapse toggler={`toggler-org-chart`}>
          {
            <SortableTree
              treeData={staticHierarchy}
              generateNodeProps={({ node, path }) => {
                  return {
                      className: 'drag-node ',
                  };
              }}
              onChange={this.handleTreeChange}
              canDrag={({ node }) => !node.dragDisabled}
              isVirtualized={false}
        />
          }
        </UncontrolledCollapse>
        
      </div>
    )
  }


  showTypesCollapse = (type, name) => {
    console.log(type)
    let {mapping} = this.props.existingMapping;
    let  value = mapping[type];
    console.log(value)
    let toggle = `toggler-${type}`
    console.log(toggle)
    if(type) {
      return(
        <div>
          <div className="review-mapping-row">
            <div>
              Matched Column: <span style={{fontWeight:'lighter'}}>{value && value.columnName?value.columnName:null}</span>
            </div>
          </div>
          
          <div className="review-mapping-row" id={`toggler-value-${type}`}>
            <div>
              Mapped {value && value.data.length} of {value && value.data.length} values to {name} categories
            </div>
            <div>
              <i className="review-mapping-row flaticon-down"></i>
            </div>
          </div>
          <UncontrolledCollapse toggler={`toggler-value-${type}`}>
          {
            value && value.data.map((data,i) => {
              return(
                <div key={i} className="review-mapping-collapse">
                  {data.values.join(', ')} 
                  <span style={{fontWeight:'lighter',marginLeft:'5px'}}>
                  mapped to
                  </span> {data.reference.name}
                </div>
              )
            })
          }
          </UncontrolledCollapse>
          
        </div>
      )
    }
  }

  render() { 
    // console.log(this.props.existingMapping);
    return ( 
      <div className="">
        <div className="title-text" style={{fontWeight:'bolder'}}>
          Review Mappings
        </div>
        <hr style={{marginBottom:'30px'}}/>
        <div className="mt40">
          <div className="mb40 import-data-description-txt">
            {/* {categoryDescription} */}
            Before you continue, please review and confirm the mappings below. The data uploaded will be 
            only those  matched/mapped to the specific employee data fields, and the enterprise 
            organizational hierarchy, as indicated.
          </div>
          <div className="col-lg-10 col-md-10">
            <div className="review-mapping">  
              <div className="title">Org Chart</div>
              {
                this.showOrgChartCollapse()
              }
            </div>
            <div className="review-mapping"> 
              <div className="title">Gender Category</div>
              {
                this.showGenderTypesCollapse()
              }
            </div>
            <div className="review-mapping"> 
              <div className="title">Ethnicity/Race Category</div>
              {
                this.showEthnicityTypesCollapse()
              }
            </div>




            <div className="review-mapping"> 
              <div className="title">Sexual Orientation</div>
              {
                this.showTypesCollapse("sexualOrientation", "Sexual Orientation")
              }
            </div>
            <div className="review-mapping"> 
              <div className="title">Disability</div>
              {
                this.showTypesCollapse("disability", "Disability")
              }
            </div>
            <div className="review-mapping"> 
              <div className="title">Religion</div>
              {
                this.showTypesCollapse("religion", "Religion")
              }
            </div>
            <div className="review-mapping"> 
              <div className="title">Veteran Status</div>
              {
                this.showTypesCollapse("veteran", "Veteran")
              }
            </div>




            <div className="review-mapping">  
              <div className="title">Occupations and Job Category</div>
              {
                this.showOccupationsAndSeniorityCollapse()
              }
            </div>
            <div className="review-mapping">  
              <div className="title">Performance Ratings</div>
              {
                this.showPerformanceGradeCollapse()
              }
            </div>
            <div className="review-mapping">  
              <div className="title">Separation Category</div>
              {
                this.showSeprationCollapse()
              }
            </div>
          <div className="mt40">
            <InfoMessage
              msg="Mappings don't look right?"
              subMsg="Please go to enterprise settings, to make the necessary changes before you proceed."
            />
          </div>
          </div>
          <Button
            className="continueBtn float-right clearfix mb10 mt30 reviewMappingsBtn"
            onClick={this.props.nextStep}>
            <span className="continueBtnTxt">
              Continue <span className="ml10 flaticon-next" />
            </span>
          </Button>
        </div>
      </div>
    );
  }
}
 
export default ReviewMapping;